import { createContext } from "react";

export interface DemoModeContextValue {
  demoMode: boolean;
  setDemoMode: (value: boolean) => void;
  toggleDemoMode: () => void;
}

export const DemoModeContext = createContext<DemoModeContextValue | null>(null);
